<template>
<div v-if="relevant()" @click="$emit('show-info', tip)" v-bind:class="{ 'configurator__notice--ok': tip.type == 'info',  'configurator__notice--neutral': tip.type == 'additional'}" class="configurator__notice box">
    <article class="media">
        <div class="media-left">
            <img class="icon" v-if="tip.type == 'info'" alt="" src="/modules/custom/wn_conf/assets/img/icon-wassernator.svg">
            <img class="icon" v-if="tip.type == 'additional'" alt="" src="/modules/custom/wn_conf/assets/img/icon-thumb.svg">
        </div>
        <div class="media-content">{{ tip.title }}</div>
    </article>
</div>
</template>

<script>
module.exports = {
    props: ['tip']
    ,
    computed: {
    }
    ,  
    methods: {

        relevant: function() {
            if(this.tip.condition == undefined) {
                return true;
            }
            else {
                return this.tip.condition(this.$parent);
            }
        } 

    }
    ,
    mounted () {
    }
}
</script>

<style scoped>
    .icon {
        height: 1.5em;
    }
</style>